import { Component, Input } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'user-pending-invite',
    templateUrl: './user-pending-invite.component.html',
    styleUrls: ['./user-pending-invite.component.css'],
    standalone: false
})
export class UserPendingInviteComponent {
  constructor(private dialog: NgbModal, private route: Router) {}
  url = '';
  @Input() info: any = {};
  @Input() showGetstart = true;
  @Input() showDontshowClick = true;
  dontShowAgain = false;
  showVideo = false;

  closeModel() {
    this.dialog.dismissAll();
  }

  PendingInvite() {
    const navigationExtras: NavigationExtras = {
      state: {
        isProfessional: true,
      },
    };
    this.route.navigateByUrl('/user/pendinginvitations', navigationExtras);
    this.closeModel();
  }
}
